import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-edit-custom-speedos',
  templateUrl: './edit-custom-speedos.component.html',
  styleUrls: ['./edit-custom-speedos.component.css'],
})
export class EditCustomSpeedosComponent {
  @Output() saveCustomSpeedosEvent = new EventEmitter<any>();
  modalLabel: any;

  submitted = false;
  customSpeedoData: any;
  customSpeedosEditForm!: FormGroup;
  speedoItemList: any;
  speedosItems: any;
  speedosID: any;
  validationFlag: any;

  constructor(private formBuilder: FormBuilder, private modal: CustomModalService) {
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['headerName'];
    this.customSpeedoData = this.modal?.modalService?.config?.initialState?.['customSpeedosData'];
    this.speedoItemList = this.customSpeedoData.speedosItems;
  }

  ngOnInit(): void {
    this.customSpeedosEditForm = this.formBuilder.group({
      indicators: [this.customSpeedoData.speedosIds || null, [Validators.required]],
    });
  }

  onClose() {
    this.modal.close();
  }
  onSave() {
    this.submitted = true;
    this.speedosID = this.speedosItems.map((data: any) => {
      return data.id;
    });
    if (this.speedosID.length == 3) {
      const speedoEditPayload = {
        speedosIds: this.speedosID,
      };
      this.saveCustomSpeedosEvent.emit(speedoEditPayload);
    }
  }

  selectProduct(event: any) {
    this.validationFlag = event.length == 3 ? true : false;
    this.speedosItems = event;
  }
}
